import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { loadToken, removeSession } from '../utils';
import config from '../config/config';
import { handlerError } from '../errors/handlerError';

const useUser = () => {
  const navigate = useNavigate();

  const logout = async () => {
    const token = loadToken();

    let res = await axios({
      method: 'DELETE',
      url: `${config.DOMAIN}users/logout`,
      headers: {
        token,
        apikey: config.apikey
      },
      params: { token }
    })
      .then(async () => {
        await removeSession();
        navigate('/login');
      })
      .catch(async error => {
        handlerError(error);
        if (error.response?.data?.message === 'Unauthorized access') {
          await removeSession();
          navigate('/login');
        }
      });
    return res;
  };

  return { logout };
};

export default useUser;
